import { useObserveTableElementRef } from '../../virtualization/hooks/useObserveTableElementRef';
import { COLUMN } from '../../virtualization/types/observerTypes';
import ContentComponentInner from './ContentComponentInner';
import { baseWrapperStyle } from './contentComponentStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentComponentWithoutDnD({
  arrowsNode,
  children,
  columnIndex,
  columnName,
  columnNamespace,
  isLastColumn
}) {
  const handleObserveRef = useObserveTableElementRef();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      style: baseWrapperStyle,
      ref: handleObserveRef,
      "data-observer-type": COLUMN,
      "data-observer-id": columnIndex,
      "data-test-id": `content-component-no-dnd-${columnName}`,
      children: /*#__PURE__*/_jsx(ContentComponentInner, {
        arrowsNode: arrowsNode,
        columnName: columnName,
        columnNamespace: columnNamespace,
        isLastColumn: isLastColumn,
        children: children
      })
    })
  );
}